export default "__VITE_ASSET__be075072__"